import React, { memo, useCallback } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './wizard-navigation.less';

const WizardNavigation = memo(
	({ stepsContent, onValueChange, currentStep, showCheckbox, clickableSteps }) => {
		const isEnabled = useCallback(step => step === 0 || stepsContent[step - 1].valid, [
			stepsContent,
		]);

		const isActive = useCallback(step => currentStep === step, [currentStep]);

		const wasVisited = useCallback(step => currentStep > step, [currentStep]);

		const changeStep = useCallback(
			step => {
				if (!isEnabled(step)) {
					return;
				}
				onValueChange(step);
			},
			[isEnabled, onValueChange],
		);

		const stepClass = useCallback(
			index =>
				classNames('stacked-step-container text-center', {
					active: isActive(index),
					enabled: isEnabled(index),
					visited: wasVisited(index),
				}),
			[isActive, isEnabled, wasVisited],
		);

		if (!stepsContent) return <div />;

		return (
			<div className="react-wizard-navigation-container">
				<hr className="line" />
				<div className="stacked-steps">
					{stepsContent.map((value, index) => (
						<div
							key={index}
							value={index}
							onClick={clickableSteps ? () => changeStep(index) : undefined}
							className={stepClass(index)}
						>
							<div className="stacked-step-number">
								{showCheckbox ? <i className="fa fa-check" /> : index + 1}
							</div>
							<div className="stacked-step-title text-disabled">{value.title}</div>
						</div>
					))}
				</div>
			</div>
		);
	},
);

WizardNavigation.defaultProps = {
	stepsContent: undefined,
	showCheckbox: false,
	clickableSteps: true,
};

WizardNavigation.propTypes = {
	stepsContent: PropTypes.arrayOf(
		PropTypes.shape({
			valid: PropTypes.bool,
			title: PropTypes.string,
		}),
	),
	currentStep: PropTypes.number.isRequired,
	onValueChange: PropTypes.func.isRequired,
	showCheckbox: PropTypes.bool,
	clickableSteps: PropTypes.bool,
};

export default WizardNavigation;
